module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": _vm.listName,
      "visible": _vm.dialogVisible,
      "destroy-on-close": true
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      },
      "open": _vm.fetchContacts,
      "closed": _vm.clearContacts
    }
  }, [(_vm.$apollo.loading) ? _c('loader', {
    attrs: {
      "msg": "Loading Contacts"
    }
  }) : _vm._e(), _vm._v(" "), _vm._l((_vm.listContacts), function(contact) {
    return _c('div', {
      key: contact.id
    }, [_c('span', [_vm._v(_vm._s(contact.firstName) + " " + _vm._s(contact.lastName))])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a61f25dc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"multiple":[{"search":"logo-white[.]svg","replace":"logo-white-live.svg","flags":"g"},{"search":"_variables","replace":"_variables_live","flags":"g"},{"search":"_theme","replace":"_live","flags":"g"}]}!./src/components/audience/ContactsListDialog.vue
// module id = 3377
// module chunks = 3